import React, { useEffect, useState } from 'react'
import Title from '../../../components/panelcontrols/paneltitle'
import OrderTable from './orderTable'
import OrderStatusSelector  from './orderStatusSelector'
import OrderFunctions from '../orders/list/functions'
import './index.css'

const Index = () => {
  const [selectedStatus,setSelectedStatus] = useState(0);
  const [orderList,setOrderList] = useState([]);
  // Starts true so the first paint is a shimmer rather than "No data available".
  // apiGetList guarantees applyList runs even on failure, so this always clears.
  const [loading,setLoading] = useState(true);
  const applyList = (data)=>{
    setOrderList(data);
    setLoading(false);
  };
  useEffect(()=>{
    if(selectedStatus === 0){
      OrderFunctions.Get(applyList, null, 1, 50)
    }
    else{
      OrderFunctions.GetByStatus(selectedStatus, applyList, null, 1, 100)
    }
  },[selectedStatus])
  return (
    <div className='labadmin_dashboard_container'>
      <Title Value={'Dashboard'}/>
      <OrderStatusSelector selectedStatus={selectedStatus} setSelectedStatus={setSelectedStatus}/>
      <OrderTable List={orderList} loading={loading}/>
    </div>
  )
}

export default Index
